module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "options"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "options-title"
  }, [_vm._v(_vm._s(_vm.tokens['hdr_settings']))]), _c('div', {
    ref: "container",
    staticClass: "options"
  }), _c('div', {
    staticClass: "buttons"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_save_close']))]), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.apply
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_apply']))]), _c('button', {
    staticClass: "button is-danger",
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(_vm._s(_vm.tokens['btn_reset']))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bad2478"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vis/Options.vue
// module id = 426
// module chunks = 0